import { NavbarButton } from '@veranda/shared/layout/navbar';
import { cn } from '@veranda/shared/lib';

export function SearchButtonComponent({
  isOpen,
  setIsOpen,
  className,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  className?: string;
}) {
  return (
    <NavbarButton
      icon={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          className="size-6 text-primary"
          id="search-button-icon"
        >
          <title>Search</title>
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10Z"
            clipRule="evenodd"
          />
        </svg>
      }
      ariaLabel="Open search"
      onClick={() => {
        if (isOpen) {
          setIsOpen(false);
        } else {
          setIsOpen(true);
        }
      }}
      className={cn(
        'flex items-center gap-1 p-2 text-brand-burgundy',
        className
      )}
    />
  );
}
